import { render, staticRenderFns } from "./workplace.vue?vue&type=template&id=d6f4a3a6&"
import script from "./workplace.vue?vue&type=script&lang=js&"
export * from "./workplace.vue?vue&type=script&lang=js&"
import style0 from "./workplace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports